module.exports = __webpack_public_path__ + "img/112.039056af.jpg";